import SEO from '@/components/seo/SEO'

/**
 * Stub Privacidad (D3). Texto legal definitivo lo provee FITLAB (R-408 PRD).
 * SEO D10: title + description + canonical específicos.
 */
export default function Privacidad() {
  return (
    <>
      <SEO
        title="Política de Privacidad — FITLAB"
        description="Política de privacidad de FITLAB. Tratamiento de datos personales conforme a la Ley 19.628 de Protección de la Vida Privada en Chile."
        canonical="https://fitlab.cl/privacidad"
      />
      <div className="mx-auto max-w-3xl px-4 pt-32 pb-24 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold tracking-tight text-fitlab-neutral-900 sm:text-5xl">
          Política de privacidad
        </h1>
        <div className="mt-8 space-y-6 text-base leading-relaxed text-fitlab-neutral-600">
          <p>
            FITLAB trata datos personales de acuerdo con la Ley 19.628 sobre Protección de la Vida
            Privada.
          </p>
          <p className="italic">
            El texto legal definitivo de esta política será provisto por FITLAB antes de la
            publicación productiva (R-408 PRD F4).
          </p>
        </div>
      </div>
    </>
  )
}
